import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

// REDUX
import { useAppSelector } from '@Managers/Redux/Hooks';
import { getDeviceInfo, getLeftHandMode, getWCAMode, setGlobalStyles } from '@Managers/Redux/AppState/AppState';

//TYPES
import { TWindowOrientation } from './UseWindowDimensions.types';

//STYLES
import styles from '@UILayer/UILayer.scss';

export const UseGlobalStyles = (): void => {
    const dispatch = useDispatch();
    const device = useAppSelector(getDeviceInfo);
    const wcaMode = useAppSelector(getWCAMode);
    const leftHandMode = useAppSelector(getLeftHandMode);

    useEffect(() => {
        const orientationStyles = device.windowOrientation === TWindowOrientation.horizontal ? styles.horizontal : styles.portrait;
        const deviceStyles = device.isMobile ? styles.mobile : styles.desktop;

        dispatch(
            setGlobalStyles({
                orientation: orientationStyles,
                device: deviceStyles,
                wcaMode: wcaMode ? styles.wcaModeTrue : styles.wcaModeFalse,
                handMode: leftHandMode ? styles.leftHandModeTrue : styles.leftHandModeFalse,
                wideDevice: device.appWidth > 1280 ? styles.wideDevice : {},
                screenSize: styles[device.screenSize],
                isTablet: device.isTabletHorizontal ? styles.isTabletHorizontal : device.isTabletPortrait ? styles.isTabletPortrait : false
            })
        );
    }, [device, wcaMode, leftHandMode]);
};
